const sortedApplicationsNames = [
    { order: 1, name: "pharmacy" },
    { order: 2, name: "infection prevention" },
    { order: 3, name: "simplifi 797" },
    { order: 4, name: "analytics" },
    { order: 5, name: "quantifi" },
    { order: 6, name: "veriform" },
    { order: 7, name: "user management" },
    { order: 8, name: "rule management" },
    { order: 9, name: "super user" }
];

class ApplicationsSortingUtility {
    static sortByApplicationName (a, b) {
        const aApp = sortedApplicationsNames.find(item => a.name.toLowerCase() == item.name);
        const bApp = sortedApplicationsNames.find(item => b.name.toLowerCase() == item.name);

        if (aApp && bApp){
            return aApp.order - bApp.order;
        } else {
            return 0;//for prevention of error if new product was added but not included into sortedApplicationsNames
        }
    }
}
export default ApplicationsSortingUtility;

